let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bqfwD")).then(() => parcelRequire('gyV0H'));